import Utils from "../../utility";

const initialState = {
  list: [],
  total: 0,
  page: 1,
  limit: 20,
  unreadOnly: false,
  type: "",
  unreadCount: 0,
  loading: false,
};

export const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case Utils.ActionName.NOTIFICATION:
      return { ...state, ...action.payload };

    case Utils.ActionName.RESET_NOTIFICATION:
      return { ...initialState };

    // A brand-new notification arrived over the socket — prepend it to
    // whatever page/list is currently loaded and bump the unread badge.
    case Utils.ActionName.NOTIFICATION_NEW:
      return {
        ...state,
        list: [action.payload, ...state.list],
        total: state.total + 1,
        unreadCount: state.unreadCount + 1,
      };

    // Fired for both a single item read and a bulk "read all" — payload is
    // either { id, readAt } or { readAll: true, readAt }.
    case Utils.ActionName.NOTIFICATION_READ: {
      const { id, readAll, readAt } = action.payload;
      if (readAll) {
        return {
          ...state,
          list: state.list.map((n) => ({ ...n, readAt: n.readAt ?? readAt })),
          unreadCount: 0,
        };
      }
      const alreadyRead = state.list.find((n) => n.id === id)?.readAt;
      return {
        ...state,
        list: state.list.map((n) => (n.id === id ? { ...n, readAt } : n)),
        unreadCount: alreadyRead ? state.unreadCount : Math.max(0, state.unreadCount - 1),
      };
    }

    default:
      return state;
  }
};
